import React from 'react';
import MultiStepSubscription from '../../components/Subscriptions/MultiStepSubscription';

const Create = () => {
  return <MultiStepSubscription />;
};

export default Create;
